export default "__VITE_ASSET__CY9zpnom__"